import { assertNotNullOrUndefined } from 'record-it-utils/utils/assert/assertNotNullOrUndefined';
import { WorkTimeEntryToCreate } from '../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import { useAppSelector } from '../../store/hooks';

export function useRequiredWorkTimeEntryToCreate(): WorkTimeEntryToCreate {
  const workTimeEntryToCreate = useAppSelector(
    (state) => state.createWorkTimeEntry.workTimeEntryToCreate
  );
  assertNotNullOrUndefined(
    workTimeEntryToCreate,
    'the createWorkTimeEntry has not been started'
  );
  return workTimeEntryToCreate;
}
